/* A card shortcut uses the existing product launcher and its approval guards. */
(() => {
  if (location.hash !== '#customize-now') return;
  const product = document.querySelector('[data-cc-product]');
  if (!product) return;
  history.replaceState(history.state, '', location.pathname + location.search);
  let observer, timeout, finished = false;
  const cleanup = () => {
    finished = true;
    observer?.disconnect();
    clearTimeout(timeout);
    document.removeEventListener('pointerdown', cancel, true);
    document.removeEventListener('keydown', cancel, true);
    window.removeEventListener('pagehide', cleanup);
  };
  const cancel = event => { if (event.isTrusted) cleanup(); };
  const open = () => {
    if (finished) return;
    const root = product.querySelector('[data-nc-personalize]');
    const button = root?.querySelector('[data-nc-open]');
    if (!button) return;
    // Auto-inline products already open themselves; clicking would close them.
    if (root.hasAttribute('data-nc-auto-inline')) {
      if (root.dataset.ncAutoState !== 'ready') return;
      cleanup();
      root.scrollIntoView({ block: 'center' });
      return;
    }
    if (button.disabled || !button.getClientRects().length) return;
    cleanup();
    button.scrollIntoView({ block: 'center' });
    button.focus({ preventScroll: true });
    if (button.getAttribute('aria-expanded') !== 'true' && !root.querySelector('dialog[open]')) button.click();
  };
  observer = new MutationObserver(open);
  observer.observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-nc-auto-state', 'hidden'] });
  document.addEventListener('pointerdown', cancel, true);
  document.addEventListener('keydown', cancel, true);
  window.addEventListener('pagehide', cleanup);
  timeout = setTimeout(cleanup, 20000);
  open();
})();
